<template>
  <!-- FIXME: Set a proper `clear-button-aria-label` value. -->
  <RevInputPhone
    :id="fieldName"
    :key="`phone-${defaultCountry}`"
    v-model="model"
    autocomplete="off"
    autocorrect="off"
    class="isolation-auto"
    clear-button-aria-label=""
    data-cs-mask
    :default-country
    :description
    :error
    :label="i18n(phoneTranslations.label)"
    :name="fieldName"
    spellcheck="false"
    :translate="i18n.country"
  />
</template>

<script setup lang="ts">
import { Country } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInputPhone } from '@ds/components/InputPhone'

import phoneTranslations from '../../../translations/phone.translations'

defineOptions({
  inheritAttrs: false,
})

defineProps<{
  fieldName: string
  defaultCountry: Country
  description: string
  error?: string
}>()

const model = defineModel<string>()
const i18n = useI18n()
</script>
